import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AiFillCloseCircle } from 'react-icons/ai';
import { AiFillPlusCircle } from 'react-icons/ai';
import "./EditJob.css";
import StaffJobLandingLayout from '../../../../layouts/StaffJobLandingLayout/StaffJobLandingLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { MdArrowBackIos } from 'react-icons/md';
import { useJobContext } from '../../../../contexts/Jobs';
import { getJobs } from '../../../../services/candidateServices';
import { useCurrentUserContext } from '../../../../contexts/CurrentUserContext';
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner';
import LittleLoading from '../../../CandidatePage/views/ResearchAssociatePage/littleLoading';
import { updateJob } from '../../../../services/adminServices';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import DropdownButton from '../../../TeamleadPage/components/DropdownButton/Dropdown';


function EditJob({ subAdminView }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [updateLoading, setUpdateLoading] = useState(false)
  const [currency, setCurrency] = useState("Select Currency");
  const [isValidCurrency, setIsValidCurrency] = useState(false);
  const [formData, setFormData] = useState({
    job_title: '',
    skills: '',
    job_category: '',
    type_of_job: '',
    is_active: '',
    payment: '',
    description: '',
    time_interval: '',
    general_terms: [],
    technical_specification: [],
    payment_terms: [],
    workflow_terms: [],
    other_info: [],
    document_id: '',
    module: '',
    paymentInterval: ''
  });

  const { currentUser } = useCurrentUserContext();
  const { jobs, setJobs } = useJobContext();
  const { id } = useParams();
  const singleJob = jobs?.filter(job => job["_id"] === id)[0];
  console.log(singleJob);
  const { payment_terms, created_by, created_on, data_type, description, paymentInterval, eventId, general_terms, is_active, job_category, job_number, job_title, other_info, payment, qualification, skills, technical_specification, time_interval, type_of_job, workflow_terms, _id, module } = singleJob || {};
  const [selectedOption, setSelectedOption] = useState(job_category || "");
  const [active, setActive] = useState(is_active);
  // console.log(singleJob);
  const [typeofOption, setTypeofOption] = useState(type_of_job || "");
  const [intervalOption, setIntervalOption] = useState("");
  const [thirdOption, setThirdOption] = useState("");
  console.log(thirdOption);
  useEffect(() => {
    setSelectedOption(job_category);
    setActive(is_active);
    setTypeofOption(type_of_job);
    setThirdOption(module)
    setIntervalOption(paymentInterval)
  }, [singleJob]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // setLoading(false)
    console.log(formData);
    const isEveryGeneralTermFilled = formData.general_terms.every(
      (term) => term.length > 0
    );
    if (!isEveryGeneralTermFilled)
      return toast.info("No general term can be left empty");

    const isEveryTechnicalTermFilled = formData.technical_specification.every(
      (term) => term.length > 0
    );

    if (!isEveryTechnicalTermFilled)
      return toast.info("No technical term can be left empty");

    const isEveryPaymentTermFilled = formData.payment_terms.every(
      (term) => term.length > 0
    );
    if (!isEveryPaymentTermFilled)
      return toast.info("No payment term can be left empty");

    const isEveryWorkflowTermFilled = formData.workflow_terms.every(
      (term) => term.length > 0
    );
    if (!isEveryWorkflowTermFilled)
      return toast.info("No workflow term can be left empty");

    const isEveryOtherInfoTermFilled = formData.other_info.every(
      (term) => term.length > 0
    );
    if (!isEveryOtherInfoTermFilled)
      return toast.info("No other info term can be left empty");

    if (isEveryGeneralTermFilled)
      setUpdateLoading(true);
    return await updateJob(formData)
      .then(response => {
        setUpdateLoading(false);

        console.log(response.statusText)
        if (response.statusText === "OK") {
          setJobs(jobs.map((job) => {
            if (job._id === _id) {
              return { ...job, ...formData }
            } else {
              return job
            }
          }))
          navigate(-1);
          console.log("hello");
          toast.success("Job updated successfully");
        }
      })
      .catch(error => console.log(error));
  }


  const handleThirdOptionChange = (e) => {
    const selectedOption = e.target.value;
    console.log("Selected option:", selectedOption);
    setThirdOption(selectedOption);
    setFormData({ ...formData, module: selectedOption })
  };

  const handleIntervalChange = (e) => {
    const selectedOption = e.target.value;
    setIntervalOption(selectedOption);
    setFormData({ ...formData, paymentInterval: selectedOption })
  }

  useEffect(() => {
    if (jobs.length > 0) return setLoading(false);
    const datass = currentUser.portfolio_info[0].org_id;
    getJobs(datass).then(res => {
      setJobs(res.data.response.data.filter(job => job.data_type === currentUser?.portfolio_info[0]?.data_type));
      setLoading(false)
    }).catch(err => {
      console.log(err);
      setLoading(false)
    })
  }, [id])


  useEffect(() => {
    if (singleJob) {
      const formDataUpdates = {};

      if (singleJob.job_title?.length > 0) {
        formDataUpdates.module = singleJob.module;
        formDataUpdates.job_title = singleJob.job_title;
        formDataUpdates.description = singleJob.description;
        formDataUpdates.skills = singleJob.skills;
        formDataUpdates.job_category = singleJob.job_category;
        formDataUpdates.time_interval = singleJob.time_interval;
        formDataUpdates.payment = singleJob.payment;
        formDataUpdates.type_of_job = singleJob.type_of_job;
        formDataUpdates.is_active = singleJob.is_active;
        formDataUpdates.document_id = singleJob._id;
        formDataUpdates.general_terms = singleJob.general_terms;
        formDataUpdates.technical_specification = singleJob.technical_specification;
        formDataUpdates.payment_terms = singleJob.payment_terms;
        formDataUpdates.workflow_terms = singleJob.workflow_terms;
        formDataUpdates.other_info = singleJob.other_info;
      }

      setFormData(prevState => ({
        ...prevState,
        ...formDataUpdates
      }));
    }
  }, [singleJob]);



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    const option = e.target.value;
    setFormData({ ...formData, job_category: option })
  };

  const handltTypeOfOption = (e) => {
    setTypeofOption(e.target.value);
    const option = e.target.value;
    setFormData({ ...formData, type_of_job: option });
  }

  const toggleJobStatus = (e) => {
    setActive(!active);
    const option = !active;
    console.log(option);
    setFormData({
      ...formData,
      is_active: option,
    });
  };


  const handleRemoveGeneralTerms = (index) => {
    const newItems = [...formData.general_terms];
    const filterItems = newItems.filter((currElm, ind) => ind !== index)
    setFormData({ ...formData, general_terms: [...filterItems] })
  }

  const handleRemoveSpecificationTerms = (index) => {
    const newItems = [...formData.technical_specification];
    const filterItems = newItems.filter((currElm, ind) => ind !== index)
    setFormData({ ...formData, technical_specification: [...filterItems] })
  }

  const handleRemovePaymentTerms = (index) => {
    const newItems = [...formData.payment_terms];
    const filterItems = newItems.filter((currElm, ind) => ind !== index)
    setFormData({ ...formData, payment_terms: [...filterItems] })
  }

  const handleRemoveWorkflow = (index) => {
    const newItems = [...formData.workflow_terms];
    const filterItems = newItems.filter((currElm, ind) => ind !== index)
    setFormData({ ...formData, workflow_terms: [...filterItems] })
  }

  const handleRemoveOthers = (index) => {
    const newItems = [...formData.other_info];
    const filterItems = newItems.filter((currElm, ind) => ind !== index)
    setFormData({ ...formData, other_info: [...filterItems] })
  }

  const handleChangeInTermsArray = (valueEntered, termsKey, indexPassed) => {
    setFormData((prevValue) => {
      const copyOfPrevValueObj = { ...prevValue }
      // take a copy
      const copyOfArray = copyOfPrevValueObj[termsKey].slice()
      // modification made to the copy
      copyOfArray[indexPassed] = valueEntered;

      copyOfPrevValueObj[termsKey] = copyOfArray

      return copyOfPrevValueObj
    })
  }

  const handleAddTerm = (termsKey) => {
    // console.log(termsKey);
    setFormData((prevValue) => {
      const copyOfPrevValueObj = { ...prevValue }

      // take a copy
      const copyOfArray = copyOfPrevValueObj[termsKey]?.slice()

      // making modifications to the copy
      copyOfArray?.push("")

      copyOfPrevValueObj[termsKey] = copyOfArray

      return copyOfPrevValueObj
    })
  }

  //Handle Payment
  const [amount, currecy] = formData.payment.split(' ');

  const currencyList = ["USD", "NGN", "GBP", "INR"];

  const handleCurrencyChange = (value) => {
    console.log(value);
    setCurrency(value);
    setIsValidCurrency(value !== "Select Currency");

    const trimmedAmount = amount.toString().trim();
    const newPayment = trimmedAmount + " " + value.trim();
    console.log(newPayment);
    setFormData({ ...formData, payment: newPayment });
  };


  const handlePayment = (value) => {
    const filteredValue = value.replace(/\D/g, "");

    const trimmedValue = filteredValue.toString().trim();
    const trimmedCurrency = currency == 'Select Currency' ? currecy.trim() : currency.trim();
    const payment = trimmedValue + " " + trimmedCurrency;
    console.log(payment);
    setFormData({ ...formData, payment: payment })
  }

  if (loading) return <LoadingSpinner />

  return (
    <>
      <StaffJobLandingLayout 
        adminView={true}
        adminAlternativePageActive={true}
        pageTitle={"Edit  Job"}
        showAnotherBtn={true}
        btnIcon={<MdArrowBackIos size="1.5rem" />}
        handleNavIcon={() => navigate(-1)}
        subAdminView={subAdminView}
        newSidebarDesign={!subAdminView ? true : false}
      >
        <Wrapper>
          <div className="container edit__page_Admin__T">
            <div className="job__details">
              <div className="job__detail__title">
                <h3>Job Details</h3>
              </div>
              <form>
                <div className='input__data'>
                  <label htmlFor="job_title">Name of Job</label>
                  <input
                    type="text"
                    id="job_title"
                    name="job_title"
                    // placeholder='UI Design'
                    defaultValue={job_title}
                    onChange={handleInputChange}
                  />
                </div>
                <div className='input__data'>
                  <label htmlFor="skills">Skills</label>
                  <input
                    type="text"
                    id="skills"
                    name="skills"
                    // placeholder='Figma, XD'
                    defaultValue={skills}
                    onChange={handleInputChange}
                  />
                </div>
                <div className='input__data'>
                  <label htmlFor="qualification">Qualification</label>
                  <input
                    type="text"
                    id="qualification"
                    name="qualification"
                    defaultValue={qualification}
                    onChange={handleInputChange}
                  />
                </div>
                <div className='input__data'>
                  <label htmlFor="job_category">Job Category</label>
                  <div className="input__data__row">
                    <div className="data">
                      <input type="radio"
                        id="freelancer"
                        name="options"
                        value="Freelancer"
                        checked={selectedOption === 'Freelancer'}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="freelancer">Freelancer</label>
                    </div>

                    <div className="data">
                      <input
                        type="radio"
                        id="employe"
                        name="options"
                        value="Employee"
                        checked={selectedOption == 'Employee'}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="employe">Employee</label>
                    </div>

                    <div className="data">
                      <input
                        type="radio"
                        id="internship"
                        name="options"
                        value="Internship"
                        checked={selectedOption === 'Internship'}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="internship">Internship</label>
                    </div>

                    <div className="data">
                      <input
                        type="radio"
                        id="research_associate"
                        name="options"
                        value="Research_Associate"
                        checked={selectedOption === 'Research_Associate'}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="research_associate">Research Associate</label>
                    </div>
                  </div>
                </div>


                {selectedOption?.length < 1 ? (
                  <></>
                ) : selectedOption === "Freelancer" ? (
                  <>
                    <div className='input__data'>
                      <label htmlFor="job_category">Type of Job</label>
                    </div>
                    <div className="type_of_job">

                      <div className="data">
                        <input
                          type="radio"
                          id="time"
                          name="Task based"
                          value="Task based"
                          checked={typeofOption === 'Task based'}
                          onChange={handltTypeOfOption}
                        />
                        <label htmlFor="employe">Task Based</label>
                      </div>

                      <div className="data">
                        <input
                          type="radio"
                          id="task"
                          name="Time based"
                          value="Time based"
                          checked={typeofOption === 'Time based'}
                          onChange={handltTypeOfOption}
                        />
                        <label htmlFor="employe">Time Based</label>
                      </div>

                    </div>
                  </>
                ) : selectedOption === "Internship" ? (
                  <>
                    <div className='input__data'>
                      <label htmlFor="job_category">Type of Job</label>
                    </div>
                    <div className="type_of_job">
                      <div className="data">
                        <input
                          type="radio"
                          id="Full time"
                          name="Full time"
                          value="Full time"
                          checked={typeofOption === 'Full time'}
                          onChange={handltTypeOfOption}
                        />
                        <label htmlFor="internship">Full Time</label>
                      </div>
                      <div className="data">
                        <input
                          type="radio"
                          id="Full time"
                          name="Part time"
                          value="Part time"
                          checked={typeofOption === 'Part time'}
                          onChange={handltTypeOfOption}
                        />
                        <label htmlFor="employe">Part Time</label>
                      </div>

                    </div>
                  </>
                ) : selectedOption === "Employee" ? (
                  <>
                    <div className='input__data'>
                      <label htmlFor="job_category">Type of Job</label>
                    </div>
                    <div className="type_of_job">
                      <div className="data">
                        <input
                          type="radio"
                          id="Full time"
                          name="Full time"
                          value="Full time"
                          checked={typeofOption === 'Full time'}
                          onChange={handltTypeOfOption}
                        />
                        <label htmlFor="employe">Full Time</label>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}

                <div className='input__data'>
                  <label htmlFor="skills">Time Period</label>
                  <input
                    type="text"
                    id="time_interval"
                    name="time_interval"
                    // placeholder='1 Week'
                    defaultValue={time_interval}
                    onChange={handleInputChange}
                  />
                </div>

                <div className='input__data__row stateofjob'>
                  <label style={{ fontSize: "1rem" }}>State of Job</label>
                  <div className="data">
                    <input
                      className="active_checkbox"
                      type="checkbox"
                      name={"is_active"}
                      checked={active}
                      onChange={toggleJobStatus}
                      required
                    />
                  </div>
                </div>

                <div className='input__data'>
                  <label htmlFor="module">Module</label>
                  <select
                    className="select"
                    name={"module"}
                    id="module"
                    value={thirdOption}
                    onChange={handleThirdOptionChange}
                  >
                    <option value="Frontend" selected={thirdOption === "Frontend"}>
                      Frontend
                    </option>
                    <option value="Backend" selected={thirdOption === "Backend"}>
                      Backend
                    </option>
                    <option value="UI/UX" selected={thirdOption === "UI/UX"}>
                      UI/UX
                    </option>
                    <option
                      value="Virtual Assistant"
                      selected={thirdOption === "Virtual Assistant"}
                    >
                      Virtual Assistant
                    </option>
                    <option value="Web" selected={thirdOption === "Web"}>
                      Web
                    </option>
                    <option value="Mobile" selected={thirdOption === "Mobile"}>
                      Mobile
                    </option>
                  </select>
                </div>

                <div className='input__data'>
                  <div>
                    <label htmlFor="payment">Payment</label>
                    <div className="payment_section">
                      <DropdownButton
                        className="currency"
                        currentSelection={currecy}
                        handleSelectionClick={(value) => {
                          handleCurrencyChange(value);
                        }}
                        onChange={handlePayment}
                        selections={currencyList}
                        removeDropDownIcon={false}
                      />
                      <input
                        type="text"
                        className="payment_input"
                        name="payment"
                        value={amount}
                        onChange={(e) => { handlePayment(e.target.value) }}
                        placeholder="Enter your amount"
                        required
                      />

                    </div>
                  </div>
                </div>

                <div className='input__data'>
                  <label htmlFor="module">Payment Interval</label>
                  <select
                    className="select"
                    name={"paymentInterval"}
                    id="module"
                    value={intervalOption}
                    onChange={handleIntervalChange}
                  >
                    <option value="" selected={intervalOption === "" || !intervalOption} disabled>
                      Select payment interval
                    </option>
                    <option value="hour" selected={intervalOption === "hour"}>
                      Per Hour
                    </option>
                    <option value="week" selected={intervalOption === "week"}>
                      Per Week
                    </option>
                    <option value="day" selected={intervalOption === "day"}>
                      Per Day
                    </option>
                    <option value="month" selected={intervalOption === "month"}>
                      Per Month
                    </option>
                    <option
                      value="year"
                      selected={intervalOption === "year"}
                    >
                      Per Year
                    </option>
                  </select>
                </div>

                <div className='input__data'>
                  <label htmlFor="description">Description</label>
                  <textarea
                    id="description"
                    name="description"
                    defaultValue={description}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="gernaral__term">
                  <label>General Terms</label>
                  <div className="general__items">
                    {
                      React.Children.toArray(formData.general_terms?.map((x, i) => {
                        return <div className="item">
                          <p> <input value={x} placeholder="genaral term" onChange={(e) => handleChangeInTermsArray(e.target.value, "general_terms", i)} /> </p>
                          <AiFillCloseCircle onClick={() => { handleRemoveGeneralTerms(i) }} />
                        </div>
                      }))
                    }
                  </div>

                  <div className="add__item" id='addGerarelTerm'>
                    <AiFillPlusCircle onClick={() => handleAddTerm("general_terms")} />
                    <Tooltip
                      anchorId="addGerarelTerm"
                      place="top"
                      content="Add General Terms"
                      className="tooltip"
                    />
                    <label>Add General Terms</label>
                  </div>
                </div>


                <div className="gernaral__term">
                  <label>Technical Specifications</label>
                  <div className="general__items">
                    {
                      React.Children.toArray(formData.technical_specification?.map((x, i) => {
                        return <div className='item'>
                          <p> <input value={x} placeholder="specification term" onChange={(e) => handleChangeInTermsArray(e.target.value, "technical_specification", i)} /> </p>
                          <AiFillCloseCircle onClick={() => { handleRemoveSpecificationTerms(i) }} />
                        </div>
                      }))
                    }
                  </div>
                  <div className="add__item" id='addSpecifications'>
                    <AiFillPlusCircle onClick={() => handleAddTerm("technical_specification")} />
                    <Tooltip
                      anchorId="addSpecifications"
                      place="top"
                      content="Add Technical Specifications"
                      className="tooltip"
                    />
                    <label>Add Specifications</label>
                  </div>
                </div>



                <div className="gernaral__term">
                  <label>Payment Term</label>
                  <div className="general__items">
                    {
                      React.Children.toArray(formData.payment_terms?.map((x, i) => {
                        return <div className='item'>
                          <p> <input value={x} placeholder="payment term" onChange={(e) => handleChangeInTermsArray(e.target.value, "payment_terms", i)} /> </p>
                          <AiFillCloseCircle onClick={() => { handleRemovePaymentTerms(i) }} />
                        </div>
                      }))
                    }
                  </div>
                  <div className="add__item" id='addPayment'>
                    <AiFillPlusCircle onClick={() => handleAddTerm("payment_terms")} />
                    <Tooltip
                      anchorId="addPayment"
                      place="top"
                      content="Add Payment Terms"
                      className="tooltip"
                    />
                    <label>Add Payment Terms</label>
                  </div>
                </div>

                <div className="gernaral__term">
                  <label>Workflow</label>
                  <div className="general__items">
                    {
                      React.Children.toArray(formData.workflow_terms?.map((x, i) => {
                        return <div className='item'>
                          <p><input value={x} placeholder="workflow" onChange={(e) => handleChangeInTermsArray(e.target.value, "workflow_terms", i)} /> </p>
                          <AiFillCloseCircle onClick={() => { handleRemoveWorkflow(i) }} />
                        </div>
                      }))
                    }
                  </div>
                  <div>
                    <div className="add__item" id='addWorkflow'>
                      <AiFillPlusCircle onClick={() => handleAddTerm("workflow_terms")} />
                      <Tooltip
                        anchorId="addWorkflow"
                        place="top"
                        content="Add Workflow"
                        className="tooltip"
                      />
                      <label>Add Workflow</label>
                    </div>
                  </div>

                </div>

                <div className="gernaral__term">
                  <label>Others</label>
                  <div className="general__items">
                    {
                      React.Children.toArray(formData.other_info?.map((x, i) => {
                        return <div className='item'>
                          <p><input value={x} placeholder="others" onChange={(e) => handleChangeInTermsArray(e.target.value, "other_info", i)} /> </p>
                          <AiFillCloseCircle onClick={() => { handleRemoveOthers(i) }} />
                        </div>
                      }))
                    }
                  </div>
                  <div className="add__item" id='addOthersBtn'>
                    <AiFillPlusCircle onClick={() => handleAddTerm("other_info")} />
                    <Tooltip
                      anchorId="addOthersBtn"
                      place="top"
                      content="Add Others"
                      className="tooltip"
                    />
                    <label>Add Others</label>
                  </div>

                </div>
                <button onClick={handleSubmit} className="save__button" disabled={updateLoading}>
                  {updateLoading ? <LittleLoading /> : `Save`}
                </button>
              </form>
            </div>
          </div>
        </Wrapper>
      </StaffJobLandingLayout>

    </>
  )
}

const Wrapper = styled.section`


.lds-ringg div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  margin: 8px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #f7fffc transparent transparent transparent;
}
  .container{
    width: 1300px;
    margin: auto;
    background: #ffff;
    padding-bottom: 10rem;
    .back__button {
      position: absolute;
      top: 20px;
      left: 50px;
      color:black;
      background-color: #f3f8f5;
      font-size: 20px;
      margin: 1rem 0 0 1rem;
      padding: 0.1rem 0.4rem;
      padding-top: 8px;
      border-radius: 0.5rem;
      border: none;
      box-shadow: inset 0px 1.7px 8px rgba(0, 0, 0, 0.16);
      cursor: pointer;
    }
   
    .type_of_job{
      padding: 0;
    }

    .type_of_job label{
      padding: 0 0.4rem;
      font-size: 0.8rem;
      font-weight: 400;
    }

    .main__titles{
        padding-top: 70px;
        padding: 70px 0px 20px 20px;
        h2{
            color: #005734;
            font-weight: 800;
            font-size: 32px;
            letter-spacing: 0.05em;
            display: flex;
            align-items: center;
        }

        h3{
            font-size: 1rem;
            font-weight: 600;
            color: #7c7c7c;
        }
    }
    
    .job__details{
        background-color: #F3F8F4;
        padding: 40px 35px !important;
        border-radius: 10px;
        width: 85%;
        margin: auto;
        
        .job__detail__title{
            background-color:#005734;
            color: #fff;
            padding: 1.4rem 0 1.4rem 2.4rem;
            border-radius: 1rem 1rem 0 0;
            margin: 0;

            h3{
              color:#fff;
              margin-bottom: 0;
              font-size: 1.2rem;
              font-weight: 600;
            }
        }

        form{
            padding:10px 40px;
            background-color:#fff;

            .input__data {
                display:flex;
                flex-direction: column;
                padding: 10px 0;

                label{
                    padding-bottom:4px;
                    color: #005734;
                    font-weight: 600;
                    font-size: 1rem;
                    padding: 0.6rem 0;
                }

                input {
                  padding: 1.1rem 1.1rem 1.1rem 2rem;                    border-radius: 10px;
                    border: 1px solid #005734;
                }

                textarea#description {
                    height: 258px;
                    padding: 15px;
                    border-radius: 10px;
                    border: 1px solid #005734;
                    font-family: 'poppins';
                }
            }

            .input__data__row{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                label{
                    color: #005734;
                    font-weight: 600;
                    padding: 8px 0;
                    font-size: 0.8rem;
                }

                .data{    
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    input[type="radio"] {
                        color: #005734;
                        cursor: pointer;
                    }
                      
                }

                .data label{
                    font-weight:400;
                    margin-left:10px;
                    font-size: 0.8rem;
                    color: #000;
                }
            }

            .item{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding:10px 0;
                position: relative;
                
                p{
                    font-weight: 300;
                    color: #7E7E7E;
                    font-size: 14px;
                    display: flex;
                    width: 90%;

                    input{
                      width: 750px;
                      border: none;
                      color: #7E7E7E;
                      font-size: 14px;
                    }
                }
                svg {
                    color: #B8B8B8;
                    position: absolute;
                    right: 0;
                }                

            }

            .gernaral__term{
                padding-bottom:4px;
                color: #005734;
                font-weight: 600;
            }


            .add__item {
                text-align: right;
                padding: 10px 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                cursor: pointer;

                label{
                    color: #000;
                }

                svg {
                    font-size: 40px;
                    margin-right:10px;
                }
            }

           .save__button{
                display: flex;
                align-items: center;
                background-color: #005734;
                border: none;
                padding: 10px 50px;
                color: #fff;
                font-size: 20px;
                border-radius: 10px;
                cursor: pointer;
                svg{
                    color: #fff;
                    margin-left: 10px;
                }
           }

           button.save__button:hover {
            box-shadow: 0 0px 26px 5px #005734;
            transition: 0.3s ease-in-out;
        }

        }
    }     
    }

    @media only screen and (max-width: 1300px){
        .container{
           width: 95%; 
        }
    }

    @media only screen and (max-width: 900px){
      main {
        padding: 0 40px;
      }
      .container{
        .job__details{
          padding: 0px 0px;
          border-radius: 10px;
          margin: auto;
          width: 95%;
        }

        .job__details form .gernaral__term {
          padding-bottom: 4px;
          color: #005734;
          font-weight: 600;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .add__item svg{
            width: 100%;
          }

          .add__item label{
            display: none;
          }

          .gernaral__term {
            display: flex;
          }

          .item p{
            width: 200px;
          }
      }

      }

      .staff__Jobs__Layout__Navigation__Container.admin .admin__View__Title__Container {
        justify-content: space-between;
        width: auto !important;
       }
      .item{
        p{
          input{
          }
        }
      }
    }

    @media only screen and (max-width: 510px){
        
    }

    
  `

export default EditJob;



